import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgreementService, V3APIPrivacyPolicy, V3APIUserAgreement } from '../../../shared/services/agreement.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-agreement-modal',
    templateUrl: './agreement-modal.component.html',
    styleUrls: ['./agreement-modal.component.scss']
})
export class AgreementModalComponent implements OnInit {

    @Input() data: V3APIUserAgreement | V3APIPrivacyPolicy;
    @Input() preview: boolean = false;

    isChecked: boolean = false;

    selectedLanguage: string = "";

    viewerHeading: string = "";
    viewerBody: string = "";
    createdString: string = "";

    supportedLanguages = ['en', 'sv'];

    constructor(
        public activeModal: NgbActiveModal,
        private _agreementService: AgreementService,
        private _translateService: TranslateService
    ) { }

    ngOnInit() {
        this.selectedLanguage = this._translateService.currentLang;
        this.selectAgreementData();
        this.createdString = this.data.Created.split("T")[0];
    }

    acceptAgreement() {
        this._agreementService.v3_acceptAgreement(this.data.ID).subscribe(
            success => {
                this.activeModal.close()
            },
            err => {
                console.log("Error accepting agreement:", err)
            }
        );
    }

    switchLanguage(lang: string) {
        sessionStorage.setItem("lang", lang);
        this._translateService.use(lang);
        this.selectedLanguage = lang;
        this.selectAgreementData();
    }

    selectAgreementData() {
        if (this.selectedLanguage == "sv") {
            this.viewerHeading = this.data.SvHeading;
            this.viewerBody = this.data.SvBody;
        } else {
            this.viewerHeading = this.data.EnHeading;
            this.viewerBody = this.data.EnBody;
        }
    }

    close() {
        this.activeModal.close()
    }

}
